import React from 'react'

import Nav from './components/nav/Nav'
import About from './components/About/About'
import Experience from './components/experience/Experience'
import Portfolio from './components/portfolio/Portfolio'
import Contact from './components/Contact/Contact'
import Footer from './components/footer/Footer'
import LandingPage from './components/landpage/Landpage'



const App = () => {
  return (
    <>
      <LandingPage />
      <Nav />
      <About />
      <Experience />
      <Portfolio />
      <Contact />
      <Footer />
    </>
  )
}

export default App
//https://gurpreetportfolio.netlify.app